import { axios } from '$app-web/api/axios';
import { ActivityPage, ActivitySurvey, ActivityTimeUse, ActivityWeb } from '$app-web/types';

import { Endpoints } from '../constant';

type Response = Array<ActivityPage | ActivitySurvey | ActivityTimeUse | ActivityWeb>;

export async function fetchStudyActivities(studyId: number) {
    try {
        const { data, status } = await axios.get<Response>(`${Endpoints.Activity.GetAll}?study_id=${studyId}`);

        if (status === 200) {
            return data;
        } else {
            return [];
        }
    } catch {
        return [];
    }
}
